import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgPlay = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 12C0 5.373 5.373 0 12 0c6.624.007 11.993 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12zm9.447 4.584l7.381-3.69v-.001a1 1 0 00.001-1.793L9.446 7.413A1 1 0 008 8.308v7.382a1 1 0 001.447.894z", clipRule: "evenodd" })));
};
export default SvgPlay;
//# sourceMappingURL=Play.js.map